'use client';
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

interface Props {
  data: { rank: string; count: number; color: string }[];
}

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2 shadow-xl">
      <p className="text-xs font-semibold text-zinc-300">{payload[0]?.payload?.rank}</p>
      <p className="text-xs font-mono" style={{ color: payload[0]?.payload?.color }}>{payload[0]?.value} distributors</p>
    </div>
  );
};

export default function RankDistributionChart({ data }: Props) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-zinc-300">Rank Distribution</h3>
        <span className="text-[10px] text-zinc-600">{data.reduce((s, d) => s + d.count, 0)} total</span>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 20, left: 60, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 9, fill: '#71717a' }} axisLine={false} tickLine={false} />
          <YAxis type="category" dataKey="rank" tick={{ fontSize: 9, fill: '#71717a' }} axisLine={false} tickLine={false} width={58} />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="count" radius={[0, 4, 4, 0]}>
            {data.map(d => (
              <Cell key={`rdc-${d.rank}`} fill={d.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}